/**
 * @generated SignedSource<<2245d468c1671c47c4ebf4387272597c>>
 * @relayHash d510026a7ef8f40d2d5a2e2d711088e1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ed8a8f9580c7ec72b21219d26649b20e0c8e28f18bfe4033c02c7400e5bfc02f

import type { ConcreteRequest, Query } from 'relay-runtime';
export type HelpCenterType = "ADVANCED" | "BASIC" | "CUSTOMER_SERVICE" | "HELP_HUB" | "UNIFIED" | "%future added value";
export type hubQuery$variables = {
  cloudId: string;
  hubAri: string;
  pageAri: string;
};
export type hubQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly name: {
        readonly default: string;
      } | null | undefined;
      readonly pages: ReadonlyArray<{
        readonly id: string;
        readonly name: {
          readonly default: string;
        } | null | undefined;
        readonly pageLayout: {
          readonly layoutAdf: {
            readonly content: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly content: string | null | undefined;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly type: HelpCenterType | null | undefined;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type hubQuery = {
  response: hubQuery$data;
  variables: hubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "hubAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "concreteType": "HelpCenterName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": (v4/*: any*/)
    },
    {
      "args": [
        {
          "fields": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "ids.0",
                  "variableName": "pageAri"
                }
              ],
              "kind": "ListValue",
              "name": "ids"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "HelpCenterPage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "concreteType": "HelpCenterPageName",
          "kind": "LinkedField",
          "name": "name",
          "plural": false,
          "selections": (v4/*: any*/)
        },
        {
          "concreteType": "HelpCenterPageLayout",
          "kind": "LinkedField",
          "name": "pageLayout",
          "plural": false,
          "selections": [
            {
              "concreteType": "HelpCenterLayoutAdf",
              "kind": "LinkedField",
              "name": "layoutAdf",
              "plural": false,
              "selections": [
                {
                  "concreteType": "HelpCenterLayoutAdfContentConnection",
                  "kind": "LinkedField",
                  "name": "content",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "HelpCenterLayoutAdfContentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "HelpCenterLayoutAdfContent",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "content"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "hubQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hubQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ed8a8f9580c7ec72b21219d26649b20e0c8e28f18bfe4033c02c7400e5bfc02f",
    "metadata": {},
    "name": "hubQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ea0cd24c761bafa1f79b2018f725c1e0";

export default node;
